import { ID, LineItem, Lot } from 'types';

export const matchLineItemsToLot = async ({ searchResults }: {
  searchResults: Lot[];
}): Promise<Record<ID, LineItem[]>> => {
  const lineItemsToLotMap: Record<ID, LineItem[]> = {};

  // Group the line items by lot id
  searchResults.forEach((responseLot: Lot) => {
    const lotId = responseLot.id;
    if (!lineItemsToLotMap[lotId]) {
      lineItemsToLotMap[lotId] = [];
    }

    lineItemsToLotMap[lotId] = responseLot.line_items;
  });

  return lineItemsToLotMap;
};
